var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.184 21.388c4.554-.804 8.027-5.031 8.027-10.125C25.21 5.595 20.91 1 15.606 1 10.3 1 6 5.595 6 11.263c0 5.045 3.406 9.239 7.895 10.101v2.004h-4.08v1.316h4.08v1.053h-4.08v1.316h4.08V31h3.29v-3.947h3.947v-1.316h-3.948v-1.053h3.948v-1.316h-3.948v-1.98zm2.632-10.256c0 2.906-1.915 5.263-4.276 5.263-2.362 0-4.277-2.357-4.277-5.263 0-2.907 1.915-5.264 4.277-5.264 2.361 0 4.276 2.357 4.276 5.264z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMda);
export default __webpack_public_path__ + "static/media/MDA.9ae39e9beb596a402077e58f908a3d6e.svg";
export { ForwardRef as ReactComponent };